export default [
  {
    path: '/active-hj2021/index',
    name: 'index',
    component: () => import('@/views/active-hj2021'),
    meta: {
      title: '寒假自习挑战赛-高考直通车'
    }
  },
  
]
